import React, { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useAppDispatch, useAppSelector } from "commons/store/hooks";
import { fetchUserProfile, selectUserProfile } from "core/redux/userSlice";
import PageForbidden from "core/views/PageForbidden";

type UserProfileWrapperProps = {
    children: React.ReactNode;
    roles?: string[];
};

const UserProfileWrapper = ({ children, roles }: UserProfileWrapperProps) => {
    const dispatch    = useAppDispatch();
    const userProfile = useAppSelector(selectUserProfile);
    const userRoles   = userProfile?.roles || [];

    useEffect(() => {
        dispatch(fetchUserProfile());
    }, [dispatch]);

    if (!userProfile) {
        return (
            <Box minHeight="100vh" display="flex" justifyContent="center" alignItems="center">
                <CircularProgress size={50}/>
            </Box>
        );
    }

    if (roles && !userRoles.some((role: string) => roles.includes(role))) {
        return <PageForbidden/>;
    }

    return children;
};

export default UserProfileWrapper;
